import React from 'react'
import "./Return.css"
import ReturnHead from './ReturnHead'
import ReturnPara from './ReturnPara'
const Return = () => {
  return (
    <div className='returnContainer'>
      <ReturnHead/>
      <ReturnPara/>
    </div>
  )
}

export default Return
